// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2T57A","toggleWrap":"styles_toggleWrap__1c-16","content":"styles_content__1dIT0","selectAreaCode":"styles_selectAreaCode__212_9"};